import React from 'react';

export const InstruccionesExamen = () => {
    return (
      <div>
        <p>
          Este cuestionario es con la finalidad de diagnosticar los
          conocimientos que posees de la materia, antes de iniciar a
          contestarlo, lee detenidamente las siguientes recomendaciones:
        </p>

        <div style={{ marginLeft: 30 }}>
          <p>
            <b>1.</b> Cada pregunta cuenta con tres posibles respuestas: A.B.C.
            (solo UNA es la correcta) y en el caso de inglés tendrás cuatro
            opciones de respuesta A.B.C.D. (solo UNA es la correcta).
          </p>

          <p>
            <b>2.</b> Cada sección está estimada en 80 minutos.
          </p>

          <p>
            <b>3.</b> En caso de terminar antes del tiempo previsto, revisa tus
            respuestas previo a presionar el botón “Finalizar Examen”.
          </p>

          <p>
            <b>4.</b> Al acceder a cada una de las secciones no podrás salir de
            ellas sin haber concluido ya que si lo haces tu examen quedará
            suspendido y solo se guardará el avance que tengas hasta ese
            momento.
          </p>

          <p>
            <b>5.</b> Cualquier duda que surja durante la aplicación, con
            confianza pregunta al instructor.
          </p>
        </div>

        <p>
          <b>Recuerda: </b> Lee detenidamente las preguntas y sus posibles
          respuestas.
        </p>

        <p>
          Cuando finalices las tres secciones presiona el botón de la esquina
          superior derecha "Cerrar sesión" para concluir con tu examen.
        </p>
 
        <label>¡Éxito!</label>
      </div>
    );
}